export const AppLanguageArabic = "ar";
export const AppLanguageEnglish = "en";
export const AppLanguageTurkish = "tr";
